import React from "react";
import { Button, ButtonGroup, Dropdown } from "react-bootstrap";
import { UseFieldArrayAppend, UseFieldArrayRemove, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { BundleApi, BundleItemApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import { handleTurnOnBarcodeScanner } from "../../../../../../utils/itemsTableUtils";

interface Props {
	remove: UseFieldArrayRemove;
	showBarcodeScanner: boolean;
	setShowBarcodeScanner: (value: boolean) => void;
	watchedItems: BundleItemApi[];
	form: UseFormReturn<BundleApi>;
	append: UseFieldArrayAppend<BundleApi, "items">;
	replace: UseFieldArrayAppend<BundleApi, "items">;
}

const BundleFormItemsTableActions = ({
	watchedItems,
	remove,
	setShowBarcodeScanner,
	showBarcodeScanner,
	append,
	form,
	replace,
}: Props) => {
	const { t } = useTranslation();
	const { getValues, watch, setValue } = form;
	const notEmptyItems = watchedItems.filter((_, index) => index !== watchedItems.length - 1);

	const removeItemsWithNoQuantity = () => {
		const indexes: number[] = [];
		notEmptyItems.forEach((item, index) => {
			if (!item.quantity) indexes.push(index);
		});
		remove(indexes);

		if (getValues("items").length === 0) {
			append({
				position: 0,
				product: null,
				product_id: null,
				volume: null,
				quantity: null,
				unit_fifo_cost_net_money: null,
				total_fifo_cost_net_money: null,
				comment: "",
				items: [],
			});
		}
	};

	const removeDuplicatedItems = () => {
		const indexes: number[] = [];
		const uniqueItems: BundleItemApi[] = [];
		notEmptyItems.forEach((item, index) => {
			const existingItem = uniqueItems.find((uniqueItem) => uniqueItem?.product?.name === item?.product?.name);
			if (existingItem) indexes.push(index);
			else uniqueItems.push(item);
		});
		remove(indexes);
	};

	const sortItemsAlphabetically = () => {
		const newItems = [...notEmptyItems];
		const sortedItems = newItems.sort((a, b) => (a?.product?.name || "").localeCompare(b?.product?.name || ""));
		replace(sortedItems);

		if (getValues("items").length === 0) {
			append({
				position: 0,
				product: null,
				product_id: null,
				volume: null,
				quantity: null,
				unit_fifo_cost_net_money: null,
				total_fifo_cost_net_money: null,
				comment: "",
				items: [],
			});
		}
	};

	return (
		<div>
			<Button
				onClick={() => handleTurnOnBarcodeScanner(showBarcodeScanner, setShowBarcodeScanner)}
				className="me-2"
			>
				{t("common.action.turn_on_scanner")}
			</Button>
			<Dropdown as={ButtonGroup}>
				<Dropdown.Toggle className="btn-light">{t("common.action.more", { ns: "lib" })}</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item onClick={removeItemsWithNoQuantity}>
						{t("common.action.remove_items_with_no_quantity")}
					</Dropdown.Item>
					<Dropdown.Item onClick={removeDuplicatedItems}>
						{t("common.action.remove_duplicated_items")}
					</Dropdown.Item>
					<Dropdown.Item onClick={sortItemsAlphabetically}>{t("common.action.sort_by_names")}</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</div>
	);
};

export default BundleFormItemsTableActions;
